<div [ngClass]=" ['fundo', fundo ? 'fundo-customizado' : '', side || '', fundo ? fundo : '']">	
	<div [ngClass]="['fundovideo', fundo === 'criar-conta' ? '' : 'escondeDivVideo']">
		<div *ngIf="video == 'show'" class="video">
			<iframe width="100%" height="100%" [src]="linkvideo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>		
		<img class="img-logo-vertical" src="../../assets/logos/apice-vertical-nova-identidade.png">
	</div>
	
	<div [ngClass]="fundo === 'criar-conta' ? 'menuCriarConta' : 'menu'">
		<div class="formulario">		
			<div *ngIf="video == 'show'" [ngClass]="['videoMobile', fundo === 'criar-conta' ? '' : 'escondeDivVideo']">
				<iframe width="100%" height="100%" [src]="linkvideo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			<div class="container-img">
				<img class="img-nuvem" src="../../assets/logos/apice-horizontal-nova-identidade-2.png">
			</div>			
			<ng-content></ng-content>
		</div>
	</div>
</div>